import { Component } from './component.js';
import { Label } from './label.js';

export class FieldLabel extends Component {
  static defaultOptions = {
    componentName: 'FieldLabel',
    wrap: false
  };

  constructor (options) {
    super($.extend({}, FieldLabel.defaultOptions, options));

    if (options.wrap) this.el.addClass('ca-ui-fieldlabel--wrapped');

    this.label = new Label({ text: options.label });
    this.add(this.label);

    this.fieldContainer = new Component();
    this.add(this.fieldContainer);
  }

  setField (field) {
    this.fieldContainer.add(field);
  }
}
